import IconError from "./IconError";
import IconInfo from "./IconInfo";
import type { IconStatusProps } from "./iconStatusTypes";
import IconSuccess from "./IconSuccess";
import IconWarning from "./IconWarning";

export default function IconStatus({ variant = "info", outline = false, ...props }: IconStatusProps) {
  switch (variant) {
    case "warning":
      return <IconWarning {...props} outline={outline} />;
    case "error":
      return <IconError {...props} outline={outline} />;
    case "success":
      return <IconSuccess {...props} outline={outline} />;
    case "info":
    case "default":
      return <IconInfo {...props} outline={outline} />;
  }
}
